import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";
import { COOKIES, SEPERATOR } from "./AuthenticationService";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";

class CertificateService {

    getPartnerDetails = async () => {
        const response = await axios.get(`${API_URL}/GetPartnerCertificateDetails`, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        return response.data;
    };
    generateCSR = async (keyType) => {
        const response = await axios.get(`${API_URL}/GeneratePartnerPublicKeyFromHSM?keyType=${keyType}`, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        return response.data;
    };
    storeMosipPartnerCrt = async (uploadSignedPartnerCertificateDTO) => {
        const iDMRequest = {
            Request:(uploadSignedPartnerCertificateDTO)
    };
        const response = await axios.post(`${API_URL}/UploadMosipSignedPartnerCertificate`, iDMRequest, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        return response.data;
    };
}

export default new CertificateService();
